import React, { useState, useCallback, useEffect } from 'react'
import {
  Modal,
  LegacyCard,
  Spinner,
  LegacyFilters,
  ResourceItem,
  Checkbox,
  Text,
  ResourceList,
} from '@shopify/polaris'
import { useSelector, useDispatch } from 'react-redux'
import ShopifyProductActions from 'Redux/ShopifyProductRedux'
import styles from 'Styles/ManualBookingModal.scss'
import i18n from '../translations/i18n'

function SelectConnectedVariants({
  selectedVariant,
  setSelectedVariant,
  variants,
  setSelectedProduct,
}) {
  const dispatch = useDispatch()
  const { t } = i18n

  const renderItem = (item) => {
    const { id, name } = item
    return (
      <ResourceItem
        id={id}
        accessibilityLabel={`${t('view-details')} ${name}`}
        name={name}
      >
        <div className={styles.resourceItemContainer}>
          <div className={styles.checkBox}>
            {(!selectedVariant.id || selectedVariant.id === id) && (
              <Checkbox
                label=""
                checked={selectedVariant.id === id}
                onChange={onSelectionChange(item)}
              />
            )}
          </div>

          <div className={StyleSheet.textContainer}>
            <h3>
              <Text variant="bodyMd" as="span" fontWeight="semibold">
                {name}
              </Text>
            </h3>
          </div>
        </div>
      </ResourceItem>
    )
  }

  const onSelectionChange = (item) => (value) => {
    if (value) {
      setSelectedVariant(item)
      setSelectedProduct(item.product_detail)
    } else {
      setSelectedVariant({})
      setSelectedProduct({})
    }
  }

  return (
    <div style={{ maxHeight: '60vh' }}>
      <LegacyCard>
        <p className={styles.variantText}>{t('select-connected-variant')}</p>
        <ResourceList
          resourceName={{ singular: 'variant', plural: 'variants' }}
          items={variants || []}
          renderItem={renderItem}
        />
      </LegacyCard>
    </div>
  )
}

export default SelectConnectedVariants
